import MapChartContainer from './MapChartContainer'
import { connect } from 'react-redux'

const mapStateToProps = state => {
  return {
    selectedRegionId: state.REGIONS.selectedRegionId,
    regionsData: state.REGIONS.regionsData,
    referenceRegionsData: state.REGIONS.referenceRegionsData,
    sameCountryRegionsData: state.REGIONS.sameCountryRegionsData,
    allRegionsFilter: state.FILTERS.allRegionsFilter,
    referenceRegionsFilter: state.FILTERS.referenceRegionsFilter,
    sameCountryRegionsFilter: state.FILTERS.sameCountryRegionsFilter,
    otherRegionsFilter: state.FILTERS.otherRegionsFilter,
    indicatorsData: state.INDICATORS.indicatorsData
  }
}

export default connect(mapStateToProps)(MapChartContainer)



// WEBPACK FOOTER //
// ./src/modules/Charts/Map/MapChartContainer/index.js